import { SVGProps } from "react";

const Thailand = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#F8F9F9"
      />
      <path
        d="M21.5 9H2.62199C2.22 9.93437 2 10.945 2 12C2 13.055 2.22 14.0656 2.62199 15H21.5C21.902 14.0656 22 13.055 22 12C22 11 21.902 9.93437 21.5 9Z"
        fill="#0052B4"
      />
      <path
        d="M11.9999 2C8.96904 2 6.2533 3.34859 4.41943 5.47824H19.5804C17.7466 3.34859 15.0308 2 11.9999 2Z"
        fill="#D80027"
      />
      <path
        d="M19.5805 18.5217H4.41943C6.2533 20.6514 8.96904 22 11.9999 22C15.0308 22 17.7466 20.6514 19.5805 18.5217Z"
        fill="#D80027"
      />
    </svg>
  );
};

export default Thailand;
